import {OfferDirection} from '../../../types/OfferDirection';
import {hasReservationPrices, ReservationPriceFields} from './hasReservationPrices';

/** Buying offers always show the card so they can display the price placeholder. */
export function shouldRenderReservationCard(
  offer: ReservationPriceFields & {direction: OfferDirection}
) {
  return hasReservationPrices(offer) || offer.direction === 'BUYING';
}
